import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { ArticleHeaderDesktop as View } from '../../components/article-header/desktop/component';
import type { IImage } from '../../components/article-header/models';

import type { IDepsDesktop, TArticleHeaderDesktop } from './models';
import { ArticleHeaderContainer as Component } from './container';

const imageSize: IImage = {
    height: 236,
    link: null,
    width: 558,
};

export const ArticleHeaderDesktop = createWidget<IDepsDesktop, TArticleHeaderDesktop>({
    View,
    image: imageSize,
})(Component);
